import React, {Component} from "react"

import Benefit from "@irati/deals/types/Benefit"
import {FormattedMessage} from "@irati/utils/lang"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Button from "@irati/ui/src/Button"

import FlexWrapper from "./styled/FlexWrapper"
import FlexColumn from "./styled/FlexColumn"
import ImageWrapper from "./styled/ImageWrapper"
import ImagePreview from "./styled/ImagePreview"

interface Props {
  benefit: Benefit
  onDelete: (property: string) => void
  property: string
}

class UploadedImage extends Component<Props> {
  get value(): string {
    const {benefit, property} = this.props
    return benefit[property]
  }

  render() {
    const {onDelete, property} = this.props

    if (!this.value) {
      return null
    }

    return (
      <>
        <FlexWrapper>
          <ImageWrapper>
            <ImagePreview alt="preview" src={this.value} />
          </ImageWrapper>
          <FlexColumn>
            <Button small onClick={() => onDelete(property, null)}>
              <Icon icon={IconTypes.bin} small marginRight />
              <FormattedMessage id="admin.components.companyBenefits.uploadedImage.deleteButton.text" />
            </Button>
          </FlexColumn>
        </FlexWrapper>
      </>
    )
  }
}

export default UploadedImage
